module.exports = __webpack_public_path__ + "bade9257c993a93047edc1c78b9fd041.svg";